export default __webpack_public_path__ + "static/media/verify_bg2.5ea08f5a.png";